var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nvx-button-view-container"},[_c('div',[_vm._t("content")],2),_c('div',{staticStyle:{"padding-bottom":"0.5em"}},[_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }